import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as api from "./commentApi";

export const fetchComments = createAsyncThunk("comment/fetchComments", async (params, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getComments(params, token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch comments");
  }
});

export const updateCommentStatus = createAsyncThunk("comment/updateCommentStatus", async ({ id, status }, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.updateCommentStatus(id, status, token);
    toast.success(`Comment marked as ${status}`);
    return { id, status, comment: res.data };
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to update comment";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

export const deleteComment = createAsyncThunk("comment/deleteComment", async (id, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    await api.deleteComment(id, token);
    toast.success("Comment deleted successfully");
    return id;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to delete comment";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

const commentSlice = createSlice({
  name: "comment",
  initialState: {
    comments: [],
    total: 0,
    page: 1,
    pages: 0,
    loading: false,
    error: null,
    statusFilter: "all",
  },
  reducers: {
    setStatusFilter: (state, action) => { state.statusFilter = action.payload; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComments.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchComments.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload || {};
        state.comments = payload.comments || payload || [];
        state.total = payload.total || 0;
        state.page = payload.page || 1;
        state.pages = payload.pages || 0;
      })
      .addCase(fetchComments.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(updateCommentStatus.fulfilled, (state, action) => {
        const { id, status } = action.payload;
        const idx = state.comments.findIndex((c) => c._id === id);
        if (idx !== -1) state.comments[idx].status = status;
      })
      .addCase(updateCommentStatus.rejected, (state, action) => { state.error = action.payload; })

      .addCase(deleteComment.fulfilled, (state, action) => {
        state.comments = state.comments.filter((c) => c._id !== action.payload);
      })
      .addCase(deleteComment.rejected, (state, action) => { state.error = action.payload; });
  },
});

export const { setStatusFilter } = commentSlice.actions;
export default commentSlice.reducer;
